<template>
  <div class="mt-2">
    <template v-if="warnings">
      <v-alert type="warning" dense v-for="(item, index) in warnings" :key="index">{{ item }}</v-alert>
    </template>
    <!-- history-->
    <template v-if="history !== null && history.length">
      <history :history="history" class="my-2" />
    </template>


    <v-form v-if="variables">
      <div class="text-h6 my-2">
        {{ categorySettings.name }}
        <span v-if="categorySettings.description" class="text-subtitle-1">
          ({{ categorySettings.description }})
        </span>
      </div>
      <v-row>
        <template v-for="(item, index) in variables" :key="index">
          <v-col v-if="item.editable == 1 || item.viewable == 1" cols="12" sm="6" md="3">
            <v-textarea v-if="
              item.datatype == 'text' ||
              item.datatype == 'raw' ||
              item.datatype == 'money'
            " :label="item.description" variant="outlined" v-model="item.value" auto-grow rows="1"
              :rules="item.datatype == 'money' ? moneyRules : noRules">

              <template v-if="item.description.length > 50" #append-inner>
                <v-tooltip location="top" :text="item.description">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props">mdi-chat-question</v-icon>
                  </template>

                </v-tooltip>
              </template>
            </v-textarea>

            <datepicker variant="outlined" v-if="item.datatype == 'date'" :label="item.description" v-model="item.value"
              prepend-inner-icon="mdi-calendar-month"></datepicker>
            <!--выбор группы-->
            <v-autocomplete :disabled="state == 3" variant="outlined" :items="item.list" item-title="name" return-object
              v-model="item.value" v-if="item.datatype == 'list'" :label="item.description" clearable multiple chips
              closable-chips @update:modelValue="item.name == 'group-list' ? onSelectGroup(item.value) : null">

              <template v-slot:chip="{ props, item }">
                <v-chip v-bind="props" variant="flat" color="green" :text="item.raw.name"></v-chip>
              </template>

              <template v-slot:item="{ props, item }">
                <v-list-item v-bind="props" :title="item.raw.name"></v-list-item>
              </template>
            </v-autocomplete>
          </v-col>
        </template>

      </v-row>
      <!--выбранные студенты-->
      <component v-if="!loadingUsers" :is="computedStudentVarsComponent" :state="state" :categoryid="categoryid"
        :data="users" :possibleValues="possibleValues">
      </component>
      <v-skeleton-loader v-else type="article"></v-skeleton-loader>
    </v-form>
    <v-skeleton-loader v-else type="article"></v-skeleton-loader>


    <!-- action buttons -->
    <action-buttons v-if="availableActions" :id="id" :variables="variables" :users="users" :templates="templates"
      :actionButtons="availableActions" @reload-doc="reload" @clear-vars="clearVars" v-model:processData="processData">
    </action-buttons>
    <v-overlay v-model="processData" class="align-center justify-center">
      <v-progress-circular color="primary" size="64" indeterminate></v-progress-circular>

    </v-overlay>
  </div>
</template>

<script>
import history from "./order-history.vue";
import actionButtons from "./action-buttons.vue";
import datepicker from "moodleDir/procollege/lib/vue/datepicker.vue"
import defaultView from "./orderView/default.vue"
import enrollmentView from "./orderView/enrollment.vue"
export default {
  data() {
    return {
      id: 0, //orderid
      processData: false,//обработка
      categoryid: 0,
      history: null,
      availableActions: null, //кнопки с указанием callback+доп данные
      variables: null,
      warnings: null,
      templates: null,
      categorySettings: null,
      state: null,
      possibleValues: [],
      users: [],
      noRules: [
        value => true
      ],
      loadingUsers: false,
      moneyRules: [
        value => {
          if (/^\d*(\.\d)?(\d)?$/.test(value)) return true

          return 'только число'
        },
      ],
    };
  },
  components: {
    history,
    datepicker,
    'enrollment': enrollmentView,
    'default': defaultView,
    "action-buttons": actionButtons,
  },
  computed: {
    computedStudentVarsComponent() {
      return 'default'
    }
  },
  created() {
    let params = {
      orderid: this.$route.params.id
    }

    if (this.$store.getters["documentStore/STATE"]) {
      Object.assign(params, this.$store.getters["documentStore/STATE"])
    }

    if (params.orderid == 0 && params.categoryid == 0) {
      this.$router.replace({
        path: "/documents3/",
      });
      return
    }
    this.categoryid = parseInt(params.categoryid);
    this.axios
      .post(
        this.$model.wwwroot + "/procollege/manage_groups/documents3/getOrder",
        new URLSearchParams(params)
      )
      .then((response) => {
        this.reload(response)
      })
      .catch((error) => {
        this.axiosDefaultErrorHandler(error);
      });
  },
  methods: {
    reload(response) {
      if (response.data.history != undefined) {
        this.history = response.data.history;
      }

      if (response.data.actions != undefined) {
        this.availableActions = response.data.actions;
      }

      if (response.data.warnings != undefined) {
        this.warnings = response.data.warnings;
      }

      if (response.data.templates != undefined) {
        this.templates = response.data.templates;
      }

      if (response.data.documentVariables != undefined) {
        this.variables = response.data.documentVariables;
      }

      if (response.data.categorySettings != undefined) {
        this.categorySettings = response.data.categorySettings;
      }

      if (response.data.categoryid != undefined) {
        this.categoryid = parseInt(response.data.categoryid);
        this.$store.commit("documentStore/SET_STATE", {
          categoryid: this.categoryid,
        });
      }

      if (response.data.state != undefined) {
        this.state = response.data.state;
      }

      if (response.data.possibleValues != undefined) {
        this.possibleValues = response.data.possibleValues;
      }

      if (response.data.id != undefined) {
        this.id = response.data.id;
      }
      this.$eventBus.$emit("set-crumbs", response.data.crumbs);
      //------------------------------
      if (!this.users.length) {
        this.variables.forEach((variable) => {
          if (variable.name == "group-list" && variable.value != undefined) {
            this.onSelectGroup(variable.value)
          }
        });
      }

    },
    clearVars() {
      this.variables = null;
    },
    //выбор группы в select
    onSelectGroup(selectedGroups) {
      //rm existing group
      if (selectedGroups.length < this.users.length) {
        this.users.forEach((existsGroups, index) => {
          let toRemove = true;
          selectedGroups.forEach(newGroup => {
            if (newGroup.name == existsGroups.name) {
              toRemove = false;
            }
          })
          if (toRemove) {
            this.users.splice(index, 1)
          }
        })
        return;
      }

      if (selectedGroups.length) {
        this.loadingUsers = true;
        let gids = selectedGroups.map((group) => group.id);

        let params = {
          orderid: this.$route.params.id,
          gids: gids.join()
        }
        //categoryid
        if (this.$store.getters["documentStore/STATE"]) {
          Object.assign(params, this.$store.getters["documentStore/STATE"])
        }

        this.axios.post(
          this.$model.wwwroot + "/procollege/manage_groups/documents3/getStudents",
          new URLSearchParams(params)
        )
          .then((response) => {
            this.loadingUsers = false;
            if (this.users.length == 0) {
              this.users = response.data;
              return;
            }
            //add new group
            response.data.forEach(newGroup => {
              let notExists = true;
              this.users.forEach(existsGroups => {
                if (newGroup.name == existsGroups.name) {
                  notExists = false;
                }
              })
              if (notExists) {
                this.users.push(newGroup)
              }
            })
          })
          .catch((error) => {
            this.loadingUsers = false;
            this.axiosDefaultErrorHandler(error);
          });

      }
      else {
        this.users = [];
      }
    }
  },
};
</script>
<style scoped></style>